import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Primary } from '../../primitives/Button/components/Primary.js';
import { Secondary } from '../../primitives/Button/components/Secondary.js';
import { Tertiary } from '../../primitives/Button/components/Tertiary.js';
export const Button = /*#__PURE__*/_styled(forwardRef((props, ref) => {
  const buttonProps = {
    ...props,
    disabled: props.disabled || props.loading,
    category: props.category ?? 'primary',
    variant: props.variant ?? 'info',
    size: props.size ?? 'medium',
    iconPosition: props.iconPosition ?? 'left',
    ref
  };
  switch (props.category) {
    case 'secondary':
      {
        return _jsx(Secondary, {
          ...buttonProps
        });
      }
    case 'tertiary':
      {
        return _jsx(Tertiary, {
          ...buttonProps
        });
      }
    default:
      {
        return _jsx(Primary, {
          ...buttonProps,
          category: "primary"
        });
      }
  }
}), process.env.NODE_ENV === "production" ? {
  target: "e3h78fr0"
} : {
  target: "e3h78fr0",
  label: "Button"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkJ1dHRvbi5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUEyQkkiLCJmaWxlIjoiQnV0dG9uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsganN4IGFzIF9qc3ggfSBmcm9tIFwiQGVtb3Rpb24vcmVhY3QvanN4LXJ1bnRpbWVcIjtcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCB7IGZvcndhcmRSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBQcmltYXJ5IH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9CdXR0b24vY29tcG9uZW50cy9QcmltYXJ5LmpzJztcbmltcG9ydCB7IFNlY29uZGFyeSB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQnV0dG9uL2NvbXBvbmVudHMvU2Vjb25kYXJ5LmpzJztcbmltcG9ydCB7IFRlcnRpYXJ5IH0gZnJvbSAnLi4vLi4vcHJpbWl0aXZlcy9CdXR0b24vY29tcG9uZW50cy9UZXJ0aWFyeS5qcyc7XG5leHBvcnQgY29uc3QgQnV0dG9uID0gc3R5bGVkKGZvcndhcmRSZWYoKHByb3BzLCByZWYpID0+IHtcbiAgICBjb25zdCBidXR0b25Qcm9wcyA9IHtcbiAgICAgICAgLi4ucHJvcHMsXG4gICAgICAgIGRpc2FibGVkOiBwcm9wcy5kaXNhYmxlZCB8fCBwcm9wcy5sb2FkaW5nLFxuICAgICAgICBjYXRlZ29yeTogcHJvcHMuY2F0ZWdvcnkgPz8gJ3ByaW1hcnknLFxuICAgICAgICB2YXJpYW50OiBwcm9wcy52YXJpYW50ID8/ICdpbmZvJyxcbiAgICAgICAgc2l6ZTogcHJvcHMuc2l6ZSA/PyAnbWVkaXVtJyxcbiAgICAgICAgaWNvblBvc2l0aW9uOiBwcm9wcy5pY29uUG9zaXRpb24gPz8gJ2xlZnQnLFxuICAgICAgICByZWYsXG4gICAgfTtcbiAgICBzd2l0Y2ggKHByb3BzLmNhdGVnb3J5KSB7XG4gICAgICAgIGNhc2UgJ3NlY29uZGFyeSc6IHtcbiAgICAgICAgICAgIHJldHVybiBfanN4KFNlY29uZGFyeSwgeyAuLi5idXR0b25Qcm9wcyB9KTtcbiAgICAgICAgfVxuICAgICAgICBjYXNlICd0ZXJ0aWFyeSc6IHtcbiAgICAgICAgICAgIHJldHVybiBfanN4KFRlcnRpYXJ5LCB7IC4uLmJ1dHRvblByb3BzIH0pO1xuICAgICAgICB9XG4gICAgICAgIGRlZmF1bHQ6IHtcbiAgICAgICAgICAgIHJldHVybiBfanN4KFByaW1hcnksIHsgLi4uYnV0dG9uUHJvcHMsIGNhdGVnb3J5OiBcInByaW1hcnlcIiB9KTtcbiAgICAgICAgfVxuICAgIH1cbn0pKSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUJ1dHRvbi5qcy5tYXAiXX0= */");